import React, { createContext } from 'react';
import wretch, { Wretcher } from 'wretch';

export const APIBaseUrl = process.env.VITE_API_BASE_URL || '';

// TODO: the explict any here is a nono but will leave it for a later fix
const slackTokenMiddleware = (authenticated = true) => (next: any) => (
  url: any,
  opts: any
) => {
  if (authenticated) {
    const token = localStorage.getItem('token');
    opts.headers['Authorization'] = 'Bearer ' + token;
    return next(url, opts);
  }

  return next(url, opts);
};

const client = (authenticated: boolean): Wretcher => {
  const middlewares = [];
  if (authenticated) {
    middlewares.push(slackTokenMiddleware());
  }
  return wretch()
    .url(APIBaseUrl + '/api')
    .middlewares(middlewares)
    .options({
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
};

export const UnauthenticatedClient = (baseURL: string): Wretcher => {
  return wretch()
    .url(baseURL + '/api')
    .options({
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    });
};

export const ClientProvider = createContext<(b: boolean) => Wretcher>(client);

export const WhatisClientProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  return (
    <ClientProvider.Provider value={client}>{children}</ClientProvider.Provider>
  );
};
